import { render, staticRenderFns } from "./SettingsBreadcrumb.vue?vue&type=template&id=5bab183f&scoped=true"
import script from "./SettingsBreadcrumb.vue?vue&type=script&lang=js"
export * from "./SettingsBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bab183f",
  null
  
)

export default component.exports